import { borderRadius as borderRadius$1 } from "polished";
function borderRadius(placement, value) {
  switch (placement) {
    case "all":
      return { borderRadius: value };
    case "topLeft":
      return { borderTopLeftRadius: value };
    case "topRight":
      return { borderTopRightRadius: value };
    case "bottomLeft":
      return { borderBottomLeftRadius: value };
    case "bottomRight":
      return { borderBottomRightRadius: value };
    case "top":
    case "bottom":
    case "left":
    case "right":
      return borderRadius$1(placement, value);
  }
  return void 0;
}
export {
  borderRadius
};
